import angular from 'angular';

import MobileContextService from './mobileContext.service';
import smartAppComponent from './smartAppBanner.component';

export default angular.module('fp:customerportal:common:mobile', [

])
    .component('fpSmartAppBanner', smartAppComponent)
    .service('mobileAppContext', MobileContextService);